import React from 'react';

const Button = ({ children, primary, className, loading = false, ...props }) => {
  return (
    <button
      disabled={loading}
      className={`
        px-6 py-3 rounded-md font-medium transition-all duration-300 ease-in-out relative
        ${primary 
          ? 'bg-accent text-dark hover:bg-accent/90 shadow-lg shadow-accent/20 hover:shadow-accent/30' 
          : 'bg-dark/60 backdrop-blur-sm text-light border border-light/50 hover:bg-dark/80 hover:border-light/70'}
        focus:outline-none focus:ring-2 focus:ring-accent/50 focus:ring-offset-2 focus:ring-offset-dark
        active:scale-95
        ${loading ? 'cursor-wait' : 'cursor-pointer'}
        ${className || ''}
      `}
      {...props}
    >
      <span className={`flex items-center justify-center ${loading ? 'opacity-0' : 'opacity-100'}`}>
        {children}
      </span>
      
      {loading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <svg 
            className="animate-spin h-5 w-5" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24"
          >
            <circle 
              className="opacity-25" 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="4"
            ></circle>
            <path 
              className="opacity-75" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </span>
      )}
    </button>
  );
};

export default Button;
